import { IGroup } from "./IGroup";
import Bus from "@/lib/Bus"; import { group_api, IGroupSvc } from './IGroupSvc';
 const bus: Bus = new Bus().getBus();


export class GroupSvc implements IGroupSvc {

    public async save(group: IGroup): Promise<IGroup | undefined> {
        const ret = await bus.call(group_api.save,group);
        if (ret && ret._id) return (<IGroup> ret);
        else return undefined
    }

    public async find_by_id(_id: any): Promise<IGroup|undefined>  {
        const ret = await bus.call(group_api.find_by_id,{_id:_id});
        if (ret && ret._id) {
            return (<IGroup> ret);
        }
        else return undefined
    }

    public async find_by_filter(filter: any): Promise<IGroup[]> {
        const ret = await bus.call(group_api.find_by_filter,{filter:filter});
        if (ret) {
            return (<IGroup[]> ret);
        }
        else return []
    }

    public async find_all(): Promise<IGroup[] > {
        const ret = await bus.call(group_api.find_all,{});
        if (ret) {
            return (<IGroup[]> ret);
        }
        else return []
    }

    public async del(_id: any): Promise<boolean>  {
        console.log("call")
        const ret = await bus.call(group_api.del,{_id:_id});
        if (ret) {
            return (true);
        }
        else return false
    }

}
      